import MJSONScreenshot from '@admin/components/mjson_screenshot'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (entity) => ({
  engine: 'mjson',
  entity: `forms_embeds/${entity.code}`,
  width: 100,
  height: 75,
  screenshoted_at: entity.screenshoted_at
})

const EmbedToken = ({ embed }) => (
  <div className="campaign-token">
    <div className="campaign-token-preview">
      <div className="campaign-token-preview-inner">
        <MJSONScreenshot { ...getScreenshot(embed) } />
      </div>
    </div>
    <div className="campaign-token-label">
      <div className="token-link">
        { embed.title }
      </div>
    </div>
  </div>
)

EmbedToken.propTypes = {
  embed: PropTypes.object
}

export default EmbedToken
